import { UseBulkUpdateWorkflowsData } from '@frontend/api';

export const BULK_UPDATE_WORKFLOW_STATUS_MODAL_CLOSE =
  'baq/sideNav/bulkUpdateWorkflowStatusModal/CLOSE';
export const BULK_UPDATE_WORKFLOW_STATUS_MODAL_OPEN =
  'baq/sideNav/bulkUpdateWorkflowStatusModal/OPEN';
export const BULK_UPDATE_WORKFLOW_STATUS_MODAL_SAVE =
  'baq/sideNav/bulkUpdateWorkflowStatusModal/SAVE';

export const open = ({
  quoteItemIds,
  componentIds,
}: {
  quoteItemIds: number[];
  componentIds: number[];
}) => ({
  type: BULK_UPDATE_WORKFLOW_STATUS_MODAL_OPEN,
  payload: { quoteItemIds, componentIds },
});

export const close = () => ({
  type: BULK_UPDATE_WORKFLOW_STATUS_MODAL_CLOSE,
});

export const save = ({ data }: { data: UseBulkUpdateWorkflowsData }) => ({
  type: BULK_UPDATE_WORKFLOW_STATUS_MODAL_SAVE,
  payload: { data },
});
